// src/pages/About.js
import CmsPage from "../components/pages/CmsPage";

export default function About() {
  return (
    <CmsPage
      slug="about"
      fallbackTitleAr="من نحن - مجموعة موسى"
      fallbackTitleEn="About Us - Mousa Group"
      fallbackContentAr="<p>شريكك الرائد في الحلول الرقمية، البرمجية، والاستشارات التقنية. نحن في مجموعة موسى نهدف إلى تمكين الأفراد والشركات من خوض رحلة التحول الرقمي بثقة ونجاح، عبر تقديم كورسات تعليمية متقدمة، خدمات مستقلين احترافية، استشارات تقنية، وفرص عمل واعدة.</p>"
      fallbackContentEn="<p>Your leading partner in digital, software, and technology solutions. At Mousa Group LLC, we empower individuals and businesses to navigate their digital transformation journey with confidence and success through advanced educational courses, professional freelancer services, tech consulting, and career opportunities.</p>"
    />
  );
}
